// File: client_serena/src/components/BiomarkerGenomeUploadSection.js
import React, { useState } from "react";
import {
Box,
Button,
Text,
Input,
VStack,
Heading,
useDisclosure,
useToast,
HStack
} from "@chakra-ui/react";
import TestInvoiceModal from "./TestInvoiceModal";
import { Link } from "react-router-dom";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
function BiomarkerGenomeUploadSection({ mongoUser, user, setMongoUser }) {
const toast = useToast();

const genomeModal = useDisclosure();
const biomarkerModal = useDisclosure();

const [isLoading, setIsLoading] = useState(false);

const handleTestRequest = async (type) => {
try {
setIsLoading(true);
const token = await user.getIdToken();
const res = await fetch(`${API_BASE_URL}/api/user/request-${type}-test`, {
method: "POST",
headers: { Authorization: `Bearer ${token}` },
});
const data = await res.json();

toast({
title: `${type === "genome" ? "Genome" : "Biomarker"} test requested`,
description: data.msg,
status: "success",
isClosable: true,
});

if (type === "genome") {
setMongoUser((prev) => ({
...prev,
genome: { ...prev.genome, status: data.status || "requested" },
}));
genomeModal.onClose();
} else {
setMongoUser((prev) => ({
...prev,
healthBiomarkers: {
...prev.healthBiomarkers,
status: data.status || "requested",
},
}));
biomarkerModal.onClose();
}
} catch (err) {
toast({
title: "Error",
description: "Failed to request test",
status: "error",
isClosable: true,
});
} finally {
setIsLoading(false);
}
};

return (
  <Box bgGradient="linear(to-br, green.50, white 80%)" borderRadius="2xl" boxShadow="2xl" p={{ base: 4, md: 8 }} my={6}>
    <Heading size="lg" mb={4} color="green.700" fontWeight="extrabold" textAlign="center">
      🧬 Upload or Request Genome & Biomarker Data
    </Heading>
    <Text fontSize="md" color="gray.600" mb={6} textAlign="center">
      These help us tailor your meals to your DNA, blood chemistry, and real health needs.
    </Text>
    <VStack align="stretch" spacing={8}>
      <Box bg="white" borderRadius="xl" boxShadow="md" p={5}>
        <Text fontWeight="bold" fontSize="lg" color="green.700" mb={1}>Genome Data</Text>
        <Text fontSize="sm" color="gray.600" mb={3}>
          Understand how your genes affect your metabolism, food response, and fitness goals.
        </Text>
        <Input type="file" accept=".pdf,.txt" mb={3} borderRadius="md" bg="gray.50" />
        <HStack spacing={3} mb={2}>
          <Button size="md" colorScheme="teal" borderRadius="xl" fontWeight="bold" boxShadow="sm">
            Upload Genome Data
          </Button>
          <Button size="md" colorScheme="green" borderRadius="xl" fontWeight="bold" boxShadow="sm" onClick={genomeModal.onOpen}>
            Request Genome Test
          </Button>
        </HStack>
      </Box>
      <Box bg="white" borderRadius="xl" boxShadow="md" p={5}>
        <Text fontWeight="bold" fontSize="lg" color="green.700" mb={1}>Biomarker Test</Text>
        <Text fontSize="sm" color="gray.600" mb={3}>
          Track key indicators like blood sugar, cholesterol, and vitamin levels to guide your plan.
        </Text>
        <Input type="file" accept=".pdf,.txt" mb={3} borderRadius="md" bg="gray.50" />
        <HStack spacing={3} mb={2}>
          <Button size="md" colorScheme="teal" borderRadius="xl" fontWeight="bold" boxShadow="sm">
            Upload Biomarker Test
          </Button>
          <Button size="md" colorScheme="green" borderRadius="xl" fontWeight="bold" boxShadow="sm" onClick={biomarkerModal.onOpen}>
            Request Biomarker Test
          </Button>
        </HStack>
      </Box>
      <Text fontSize="sm" mt={2} textAlign="center">
        Learn how we protect your data in our <Link to="/app/privacy" style={{ color: "#319795", fontWeight: 500 }}>Privacy Policy</Link>.
      </Text>
    </VStack>
    <TestInvoiceModal
      isOpen={genomeModal.isOpen}
      onClose={genomeModal.onClose}
      onConfirm={() => handleTestRequest("genome")}
      isLoading={isLoading}
      type="genome"
    />
    <TestInvoiceModal
      isOpen={biomarkerModal.isOpen}
      onClose={biomarkerModal.onClose}
      onConfirm={() => handleTestRequest("biomarker")}
      isLoading={isLoading}
      type="biomarker"
    />
  </Box>
);
}

export default BiomarkerGenomeUploadSection;
